import { LatLng } from 'leaflet';

export type RouteSummaryType = {
  duration: number;
  length: number;
};

export type RouteResponse = {
  routes: {
    id: string;
    sections: {
      id: string;
      polyline: string;
      summary: RouteSummaryType;
      transport: { mode: 'ferry' | 'car' };
    }[];
  }[];
};

export type HereAddressType = {
  city: string;
  countryCode: string;
  countryName: string;
  county: string;
  label: string;
  postalCode: string;
  state: string;
  stateCode: string;
  street: string;
  houseNumber: string;
};

export type HerePositionType = {
  lat: number;
  lng: number;
};

export type HereTimezoneType = {
  name: string;
  utcOffset: string;
};

export enum HereGeocodeResultType {
  Address = 'address',
  AdministrativeArea = 'administrativeArea',
  Area = 'area',
  City = 'city',
  HouseNumber = 'houseNumber',
  Locality = 'locality',
  Place = 'place',
  PostalCode = 'postalCode',
  Street = 'street',
}

export type HereGeocodeItemType = {
  id: string;
  address: HereAddressType;
  position: HerePositionType;
  title: string;
  resultType: HereGeocodeResultType;
  timeZone: HereTimezoneType;
  mapView?: {
    west: number;
    south: number;
    east: number;
    north: number;
  };
};

export enum CalculateGroundTimeType {
  DepartureTime = 'departureTime',
  ArrivalTime = 'arrivalTime',
}

export type CalculateGroundRouteParams = {
  startLocation: LatLng;
  endLocation: LatLng;
  type?: CalculateGroundTimeType;
  timestamp?: string;
};
